import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { rollaMOConfig } from "./data";

export default function RollaMOPage() {
  return <CityPageTemplate config={rollaMOConfig} />;
}